// A mortgage belongs to a single order, so a payoff detail route cannot be carried over to another order.
// It resolves to the base payoffs route instead, where the new order opens its own first payoff.
const PAYOFF_DETAIL_ROUTE = /\/payoffs\/mortgage\/[^/]+\/?$/;

/**
 * Pathname to open when the selected order tab changes: the current route with the order id swapped.
 * A pathname whose order id is not swapped (the selected tab clicked again) is returned untouched.
 * @param {string} pathname - Current location pathname.
 * @param {string} fromOrderId - Id of the order currently selected.
 * @param {string} toOrderId - Id of the order tab being selected.
 * @returns {string}
 */
export const getOrderTabPathname = (pathname, fromOrderId, toOrderId) => {
  const switchedPathname = pathname.replace(fromOrderId, toOrderId);

  return switchedPathname === pathname ? pathname : switchedPathname.replace(PAYOFF_DETAIL_ROUTE, '/payoffs');
};
